import { useState, useEffect } from "react";
import VisitService from "../services/VisitService";

function VisitList() {
  const [visits, setVisits] = useState([]);

  useEffect(() => {
    loadVisits();
  }, []);

  const loadVisits = () => {
    VisitService.getAllVisits()
      .then(res => setVisits(res.data))
      .catch(err => console.error(err));
  };

  return (
    <div style={{ padding: "30px" }}>
      <h2>Lista poseta</h2>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead style={{ backgroundColor: "#f5f5f5" }}>
          <tr>
            <th style={thStyle}>ID</th>
            <th style={thStyle}>Pacijent</th>
            <th style={thStyle}>Doktor</th>
            <th style={thStyle}>Datum</th>
            <th style={thStyle}>Napomena</th>
          </tr>
        </thead>
        <tbody>
          {visits.map(v => (
            <tr key={v.visitID} style={{ borderBottom: "1px solid #eee" }}>
              <td style={tdStyle}>{v.visitID}</td>
              <td style={tdStyle}>{v.patient.name} {v.patient.surname}</td>
              <td style={tdStyle}>{v.doctor.name} {v.doctor.surname}</td>
              <td style={tdStyle}>{v.visitDate}</td>
              <td style={tdStyle}>{v.note || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const thStyle = { padding: "10px", border: "1px solid #ccc" };
const tdStyle = { padding: "8px", border: "1px solid #ccc" };

export default VisitList;
